import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEventActions } from 'src/store/event/actions';

interface QuickStat {
    label: string;
    value: string;
    icon: React.ReactNode;
}

interface ActionCard {
    id: string;
    title: string;
    description: string;
    icon: React.ReactNode;
}

// const quickStats: QuickStat[] = [
//     {
//         label: 'Total Registrations',
//         value: '248',
//         icon: (
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
//                 <circle cx="12" cy="7" r="4" />
//             </svg>
//         )
//     },
//     {
//         label: 'Page Views',
//         value: '1,942',
//         icon: (
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
//                 <circle cx="12" cy="12" r="3" />
//             </svg>
//         )
//     },
//     {
//         label: 'Days Until Event',
//         value: '12',
//         icon: (
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
//                 <line x1="16" y1="2" x2="16" y2="6" />
//                 <line x1="8" y1="2" x2="8" y2="6" />
//                 <line x1="3" y1="10" x2="21" y2="10" />
//             </svg>
//         )
//     },
//     {
//         label: 'Status',
//         value: 'Live',
//         icon: (
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <circle cx="12" cy="12" r="10" />
//                 <polyline points="12 6 12 12 16 14" />
//             </svg>
//         )
//     }
// ];

const actionCards: ActionCard[] = [
    {
        id: 'registrations',
        title: 'Registered Users',
        description: 'View, search and manage everyone who has registered for this event.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
        )
    },
    {
        id: 'registration-setup',
        title: 'Registration Setup',
        description: 'Edit registration fields, access rules and the privacy statement.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 11l3 3L22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </svg>
        )
    },
    {
        id: 'images-style',
        title: 'Images & Style',
        description: 'Update logos, banner images, colours and fonts on the event page.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
            </svg>
        )
    },
    {
        id: 'email-notifications',
        title: 'Email & Notifications',
        description: 'Manage the confirmation email, reminders and merge fields.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="M22 6l-10 7L2 6" />
            </svg>
        )
    },
    {
        id: 'analytics',
        title: 'Analytics',
        description: 'Track registration trends, traffic sources and engagement.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="20" x2="18" y2="10" />
                <line x1="12" y1="20" x2="12" y2="4" />
                <line x1="6" y1="20" x2="6" y2="14" />
            </svg>
        )
    },
    {
        id: 'event-details',
        title: 'Event Details',
        description: 'Change the date, time, description and security settings.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
        )
    }
];

const detailRows = [
    { label: 'Content Type', value: 'Live Stream / Video' },
    { label: 'Date & Time', value: '04 Sep 2026, 10:00 (UTC+10:00) Canberra, Melbourne, Sydney' },
    { label: 'Duration', value: '01:00' },
    { label: 'Channel', value: 'Webinars' },
    { label: 'Access Level', value: 'Library User (recommended)' }
];

const EventOverview: React.FC = () => {
    const dispatch = useDispatch()
    const eventAction = useEventActions(dispatch)
    const location = useLocation()
    const navigate = useNavigate()
    const { eventId, eventName } = location.state as any
    const [copied, setCopied] = useState(false);
    const [registrationUrl, setRegistrationUrl] = useState<string>('')
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(registrationUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.log(error)
        }
    };
    const {
        singleEvent,
    } = useSelector((state: RootState) => {
        return {
            singleEvent: state.event.singleEvent,
        };
    });

    useEffect(() => {
        if (singleEvent) {
            setRegistrationUrl(singleEvent.eventURL)
        }
    }, [singleEvent])

    useEffect(() => {
        if (eventId) {
            eventAction.getSingleEventRequest(eventId)
        }
    }, [eventId])
    const handleViewRegistrationPage = () => {
        window.open(singleEvent.eventURL, '_blank');
    }
    const handleBackToEventList = () => {
        navigate('/events/event');
    };

    const handleEditEvent = () => {
        navigate(`/event/edit/${eventId}`, { state: { eventId, fromEventOverview: true } });
    };
    return (
        <div className="bg-gray-50 flex flex-col">


            <div className="px-0 sm:px-6 py-4 sm:py-6 flex-1 flex flex-col gap-5 max-w-5xl w-full mx-auto min-w-0">
                {/* Success banner */}
                <div className="bg-white rounded-xl border border-gray-200 p-4 sm:p-6">
                    <div className="flex items-start gap-3">
                        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-green-100 text-green-600 flex-shrink-0">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                        </span>
                        <div className="min-w-0">
                            <h2 className="text-lg font-semibold text-gray-900 m-0">Event setup complete!</h2>
                            <p className="text-sm text-gray-500 mt-1">
                                Your event is ready. You can share the registration link with attendees or continue managing your event.
                            </p>
                        </div>
                    </div>

                    <div className="border-t border-gray-100 mt-5 pt-5">
                        <h3 className="text-base font-semibold text-gray-900 m-0 break-words">{eventName}</h3>

                        <div className="border border-gray-200 rounded-lg p-3 sm:p-4 mt-3 min-w-0">
                            <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wide m-0 mb-1">Event Registration URL</p>
                            <a href={registrationUrl} target="_blank" rel="noreferrer" className="text-sm text-indigo-600 underline break-all flex items-start gap-1">
                                {registrationUrl}
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="flex-shrink-0">
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                    <polyline points="15 3 21 3 21 9" />
                                    <line x1="10" y1="14" x2="21" y2="3" />
                                </svg>
                            </a>

                            <div className="flex flex-col sm:flex-row sm:items-center gap-2 mt-3">
                                <button
                                    type="button"
                                    onClick={handleCopy}
                                    className="w-full sm:w-auto justify-center flex items-center gap-1.5 text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg px-4 py-2 transition-colors">
                                    {copied ? (
                                        <>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-green-600">
                                                <polyline points="20 6 9 17 4 12" />
                                            </svg>
                                            Copied!
                                        </>
                                    ) : (
                                        <>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                            </svg>
                                            Copy URL
                                        </>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => handleViewRegistrationPage()}
                                    className="w-full sm:w-auto justify-center flex items-center gap-1.5 text-sm font-semibold text-gray-700 border border-gray-200 rounded-lg px-4 py-2 hover:bg-gray-50">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                        <polyline points="15 3 21 3 21 9" />
                                        <line x1="10" y1="14" x2="21" y2="3" />
                                    </svg>
                                    View Registration Page
                                </button>
                            </div>
                        </div>

                        <p className="text-sm text-gray-400 mt-4 m-0">
                            You can update the event details, registration settings and notifications at any time from your Event
                            Overview.
                        </p>
                        <div className="flex flex-col-reverse sm:flex-row sm:items-center gap-3 mt-5">
                            <button
                                type="button"
                                onClick={handleBackToEventList}
                                className="w-full sm:w-auto justify-center flex items-center gap-2 text-sm font-semibold text-gray-600 border border-gray-200 rounded-lg px-5 py-2.5 hover:bg-gray-50">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <line x1="19" y1="12" x2="5" y2="12" />
                                    <polyline points="12 19 5 12 12 5" />
                                </svg>
                                Back to Event List
                            </button>
                            <button
                                type="button"
                                onClick={handleEditEvent}
                                className="w-full sm:w-auto justify-center flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg px-5 py-2.5">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M9 11l3 3L22 4" />
                                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                                </svg>
                                Edit Event
                            </button>
                        </div>
                    </div>
                </div>

                {/* Quick stats */}
                {/* <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                    {quickStats.map((stat) => (
                        <div key={stat.label} className="bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-3">
                            <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex-shrink-0">
                                {stat.icon}
                            </span>
                            <div>
                                <p className="text-lg font-bold text-gray-900 m-0 leading-tight">{stat.value}</p>
                                <p className="text-xs text-gray-400 m-0">{stat.label}</p>
                            </div>
                        </div>
                    ))}
                </div> */}

                {/* Manage your event */}
                {/* <div className="bg-white rounded-xl border border-gray-200 p-6">
                    <h3 className="text-base font-semibold text-gray-900 m-0">Manage Your Event</h3>
                    <p className="text-sm text-gray-400 mt-1 mb-4">Jump into any section to make changes after publishing.</p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                        {actionCards.map((card) => (
                            <button
                                key={card.id}
                                type="button"
                                className="text-left border border-gray-200 rounded-lg p-4 hover:border-indigo-300 hover:bg-indigo-50/40 transition-colors">
                                <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-indigo-50 text-indigo-600 mb-3">
                                    {card.icon}
                                </span>
                                <p className="text-sm font-semibold text-gray-900 m-0 mb-1">{card.title}</p>
                                <p className="text-xs text-gray-400 m-0">{card.description}</p>
                            </button>
                        ))}
                    </div>
                </div> */}

                {/* Event details summary */}
                {/* <div className="bg-white rounded-xl border border-gray-200">
                    <div className="px-6 pt-5 pb-3">
                        <h3 className="text-base font-semibold text-gray-900 m-0">Event Details</h3>
                    </div>
                    <dl className="px-6 pb-5 space-y-2.5">
                        {detailRows.map((row) => (
                            <div key={row.label} className="flex flex-col sm:flex-row sm:items-start gap-0.5 sm:gap-3">
                                <dt className="text-xs font-semibold text-gray-500 sm:w-40 flex-shrink-0">{row.label}</dt>
                                <dd className="text-sm text-gray-800 m-0">{row.value}</dd>
                            </div>
                        ))}
                    </dl>
                </div> */}
            </div>
        </div>
    );
};

export default EventOverview;